// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1aqyS","footer":"ModalInfo_footer__3XAKk"};